module.exports = __webpack_public_path__ + "static/img/liandong.c3b978c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/liandong.png
// module id = cO//
// module chunks = 24